<template>
    <div>
        <h1 class="mb-8 font-bold text-3xl">Técnicos</h1>

        <div class="mb-6 flex justify-between items-center">
            <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset" />

            <button class="btn-indigo" type="button" @click="openModal = true">
                <span>Agregar</span>
                <span class="hidden md:inline">Técnico</span>
            </button>
        </div>

        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="px-6 pt-6 pb-4">Nombre</th>
                    <th class="px-6 pt-6 pb-4">Teléfono</th>
                    <th class="px-6 pt-6 pb-4">Especialidad</th>
                    <th class="px-6 pt-6 pb-4">Estado</th>
                </tr>

                <tr v-for="t in tecnicos.data" :key="t.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route('tecnicos.edit', t.id)"
                            tabindex="-1">
                            {{ t.nombre }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route('tecnicos.edit', t.id)"
                            tabindex="-1">
                            {{ t.telefono }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route('tecnicos.edit', t.id)"
                            tabindex="-1">
                            {{ t.especialidad }}
                        </inertia-link>
                    </td>
                    <td class="border-t">
                        <inertia-link class="px-6 py-4 flex items-center" :href="route('tecnicos.edit', t.id)"
                            tabindex="-1">
                            {{ t.estado }}
                        </inertia-link>
                    </td>
                </tr>

                <tr v-if="tecnicos.data.length === 0">
                    <td class="border-t px-6 py-4" colspan="5">No hay técnicos registrados</td>
                </tr>
            </table>
        </div>

        <pagination class="mt-6" :links="tecnicos.links" />

        <!-- MODAL -->
        <div v-if="openModal" class="fixed inset-0 z-50 flex items-start justify-center px-4 pt-10 md:pt-16">
            <div class="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/60" @click="closeModal">
            </div>

            <div class="relative bg-white rounded-md shadow-xl overflow-hidden w-full max-w-3xl mb-10">
                <div class="px-8 py-4 bg-gray-50 border-b border-gray-100 flex justify-between items-center">
                    <div class="font-bold">Registrar Técnico</div>
                    <button type="button" class="text-gray-500 hover:text-gray-800" @click="closeModal">✕</button>
                </div>

                <div class="max-h-[80vh] overflow-y-auto">
                    <form @submit.prevent="store">
                        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                            <text-input v-model="tForm.nombre" :error="tForm.errors.nombre"
                                class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" required />

                            <text-input v-model="tForm.telefono" :error="tForm.errors.telefono"
                                class="pr-6 pb-8 w-full lg:w-1/2" label="Teléfono" />

                            <text-input v-model="tForm.email" :error="tForm.errors.email"
                                class="pr-6 pb-8 w-full lg:w-1/2" label="Email" />

                            <text-input v-model="tForm.especialidad" :error="tForm.errors.especialidad"
                                class="pr-6 pb-8 w-full lg:w-1/2" label="Especialidad" />

                            <select-input v-model="tForm.estado" :error="tForm.errors.estado"
                                class="pr-6 pb-8 w-full lg:w-1/2" label="Estado" required>
                                <option value="ACTIVO">ACTIVO</option>
                                <option value="INACTIVO">INACTIVO</option>
                            </select-input>

                            <text-input v-model="tForm.observaciones" :error="tForm.errors.observaciones"
                                class="pr-6 pb-8 w-full" label="Observaciones" />
                        </div>

                        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                            <loading-button :loading="tForm.processing" class="btn-indigo" type="submit">
                                Guardar Técnico
                            </loading-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    metaInfo: { title: 'Técnicos' },
    layout: Layout,
    components: { Pagination, SearchFilter, TextInput, SelectInput, LoadingButton },
    props: {
        filters: [Object, Array],
        tecnicos: Object,
    },
    data() {
        return {
            openModal: false,
            form: {
                search: this.filters && this.filters.search ? this.filters.search : null,
            },
            tForm: this.$inertia.form({
                nombre: null,
                cedula: null,
                telefono: null,
                email: null,
                especialidad: null,
                estado: 'ACTIVO',
                observaciones: null,
            }),
        }
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                this.$inertia.get(this.route('tecnicos'), pickBy(this.form), { preserveState: true })
            }, 150),
        },
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
        closeModal() {
            this.openModal = false
            this.tForm.clearErrors()
        },
        store() {
            this.tForm.post(this.route('tecnicos.store'), {
                preserveScroll: true,
                onSuccess: () => {
                    this.openModal = false
                    this.tForm.reset()
                    this.tForm.estado = 'ACTIVO'
                },
            })
        },
    },
}
</script>